import { ITabList } from '@/Framework/UI/Pages/Landing/Sections/Tabs/interfaces';
import SharedCustomers, { ICustomer } from '@/Framework/UI/Pages/Landing/Sections/Customers';
import IconBank from '@dealroadshow/uikit/core/components/Icon/IconBank';
import IconUsersGroup from '@dealroadshow/uikit/core/components/Icon/IconUsersGroup';
import IconAccount from '@dealroadshow/uikit/core/components/Icon/IconAccount';

import styles from './customersLogos.scss';

// Investment Banking
import bankOfAmericaLogo from '@/Framework/assets/customers/svg/bankOfAmerica.svg';
import guggenheimLogo from '@/Framework/assets/customers/svg/guggenheim.svg';
import natixisLogo from '@/Framework/assets/customers/svg/natixis.svg';
import solomonPartnersLogo from '@/Framework/assets/customers/svg/solomonPartners.svg';
import barclaysLogo from '@/Framework/assets/customers/svg/barclays.svg';
import houlihanLokeyLogo from '@/Framework/assets/customers/svg/houlihanLokey.svg';
import nomuraLogo from '@/Framework/assets/customers/svg/nomura.svg';
import peiLogo from '@/Framework/assets/customers/svg/pei.svg';
import cantorFitzgeraldLogo from '@/Framework/assets/customers/svg/cantorFitzgerald.svg';
import jefferiesLogo from '@/Framework/assets/customers/svg/jefferies.svg';
import piperSandlerLogo from '@/Framework/assets/customers/svg/piperSandler.svg';
import SVBleerinkLogo from '@/Framework/assets/customers/svg/SVBleerink.svg';
import CIBCLogo from '@/Framework/assets/customers/svg/CIBC.svg';
import raymondJamesLogo from '@/Framework/assets/customers/svg/raymondJames.svg';
import TMCapitalLogo from '@/Framework/assets/customers/svg/TMCapital.svg';
import citigroupLogo from '@/Framework/assets/customers/svg/citigroup.svg';
import lazardLogo from '@/Framework/assets/customers/svg/lazard.svg';
import RBCLogo from '@/Framework/assets/customers/svg/RBC.svg';
import UBSLogo from '@/Framework/assets/customers/svg/UBS.svg';
import EYLogo from '@/Framework/assets/customers/svg/EY.svg';
import lincolnInternationalLogo from '@/Framework/assets/customers/svg/lincolnInternational.svg';
import scotiabankLogo from '@/Framework/assets/customers/svg/scotiabank.svg';
import wellsFargoLogo from '@/Framework/assets/customers/svg/wellsFargo.svg';
import goldmanSachsLogo from '@/Framework/assets/customers/svg/goldmanSachs.svg';
import moelisLogo from '@/Framework/assets/customers/svg/moelis.svg';
import SMBCLogo from '@/Framework/assets/customers/svg/SMBC.svg';
import williamBlairLogo from '@/Framework/assets/customers/svg/williamBlair.svg';
import mizuhoLogo from '@/Framework/assets/customers/svg/mizuho.svg';

// Private Equity & Venture Capital
import LCapitalLogo from '@/Framework/assets/customers/svg/3LCapital.svg';
import cerberusLogo from '@/Framework/assets/customers/svg/cerberus.svg';
import manhattanVenturesLogo from '@/Framework/assets/customers/svg/manhattanVentures.svg';
import quilvestLogo from '@/Framework/assets/customers/svg/quilvest.svg';
import apolloLogo from '@/Framework/assets/customers/svg/apollo.svg';
import endicottGroupLogo from '@/Framework/assets/customers/svg/endicottGroup.svg';
import moderneVenturesLogo from '@/Framework/assets/customers/svg/moderneVentures.svg';
import roakCapitalGroupLogo from '@/Framework/assets/customers/svg/roakCapitalGroup.svg';
import aviditiLogo from '@/Framework/assets/customers/svg/aviditi.svg';
import FFLLogo from '@/Framework/assets/customers/svg/FFL.svg';
import heritageLogo from '@/Framework/assets/customers/svg/heritage.svg';
import shoreViewLogo from '@/Framework/assets/customers/svg/shoreView.svg';
import beachPointLogo from '@/Framework/assets/customers/svg/beachPoint.svg';
import HIGLogo from '@/Framework/assets/customers/svg/HIG.svg';
import oncapLogo from '@/Framework/assets/customers/svg/oncap.svg';
import thomabravoLogo from '@/Framework/assets/customers/svg/thomabravo.svg';
import blackRockLogo from '@/Framework/assets/customers/svg/blackRock.svg';
import jadianCapitalLogo from '@/Framework/assets/customers/svg/jadianCapital.svg';
import pagayaLogo from '@/Framework/assets/customers/svg/pagaya.svg';
import translinkLogo from '@/Framework/assets/customers/svg/translink.svg';
import blackstoneLogo from '@/Framework/assets/customers/svg/blackstone.svg';
import KKRLogo from '@/Framework/assets/customers/svg/KKR.svg';
import patonaPartnersLogo from '@/Framework/assets/customers/svg/patonaPartners.svg';
import tribecaLogo from '@/Framework/assets/customers/svg/tribeca.svg';
import carlyleLogo from '@/Framework/assets/customers/svg/carlyle.svg';
import lorientLogo from '@/Framework/assets/customers/svg/lorient.svg';
import pretiumLogo from '@/Framework/assets/customers/svg/pretium.svg';
import vineVenturesLogo from '@/Framework/assets/customers/svg/vineVentures.svg';

// Corporate
import amherstLogo from '@/Framework/assets/customers/svg/amherst.svg';
import fannieMaeLogo from '@/Framework/assets/customers/svg/fannieMae.svg';
import hiltonLogo from '@/Framework/assets/customers/svg/hilton.svg';
import pemexLogo from '@/Framework/assets/customers/svg/pemex.svg';
import carvanaLogo from '@/Framework/assets/customers/svg/carvana.svg';
import fiveGuysLogo from '@/Framework/assets/customers/svg/fiveGuys.svg';
import holidayInnLogo from '@/Framework/assets/customers/svg/holidayInn.svg';
import resimacLogo from '@/Framework/assets/customers/svg/resimac.svg';
import CECEntertainmentLogo from '@/Framework/assets/customers/svg/CECEntertainment.svg';
import fordLogo from '@/Framework/assets/customers/svg/ford.svg';
import hondaLogo from '@/Framework/assets/customers/svg/honda.svg';
import soFiLogo from '@/Framework/assets/customers/svg/soFi.svg';
import dellLogo from '@/Framework/assets/customers/svg/dell.svg';
import freddieMacLogo from '@/Framework/assets/customers/svg/freddieMac.svg';
import hyundaiLogo from '@/Framework/assets/customers/svg/hyundai.svg';
import teslaLogo from '@/Framework/assets/customers/svg/tesla.svg';
import dominosLogo from '@/Framework/assets/customers/svg/dominos.svg';
import GMFinancialLogo from '@/Framework/assets/customers/svg/GMFinancial.svg';
import marriotLogo from '@/Framework/assets/customers/svg/marriot.svg';
import toyotaLogo from '@/Framework/assets/customers/svg/toyota.svg';
import dunkinLogo from '@/Framework/assets/customers/svg/dunkin.svg';
import hertzLogo from '@/Framework/assets/customers/svg/hertz.svg';
import monsterLogo from '@/Framework/assets/customers/svg/monster.svg';
import upstartLogo from '@/Framework/assets/customers/svg/upstart.svg';
import dyeAndDurhamLogo from '@/Framework/assets/customers/svg/dyeAndDurham.svg';
import HPLogo from '@/Framework/assets/customers/svg/HP.svg';
import nissanLogo from '@/Framework/assets/customers/svg/nissan.svg';
import verizonLogo from '@/Framework/assets/customers/svg/verizon.svg';

const investmentCustomers: ICustomer[] = [
  {
    src: bankOfAmericaLogo,
    title: 'Bank Of America',
  },
  {
    src: barclaysLogo,
    title: 'Barclays',
  },
  {
    src: cantorFitzgeraldLogo,
    title: 'Cantor Fitzgerald',
  },
  {
    src: CIBCLogo,
    title: 'CIBC',
  },
  {
    src: citigroupLogo,
    title: 'Citigroup',
  },
  {
    src: EYLogo,
    title: 'EY',
  },
  {
    src: goldmanSachsLogo,
    title: 'Goldman Sachs',
    width: 71,
    height: 30,
  },
  {
    src: guggenheimLogo,
    title: 'Guggenhein',
  },
  {
    src: houlihanLokeyLogo,
    title: 'Houlihan Lokey',
  },
  {
    src: jefferiesLogo,
    title: 'Jefferies',
  },
  {
    src: lazardLogo,
    title: 'Lazard',
  },
  {
    src: lincolnInternationalLogo,
    title: 'Lincoln International',
  },
  {
    src: mizuhoLogo,
    title: 'Mizuho',
  },
  {
    src: moelisLogo,
    title: 'Moelis & Company',
  },
  {
    src: natixisLogo,
    title: 'Natixis',
  },
  {
    src: nomuraLogo,
    title: 'Nomura',
  },
  {
    src: peiLogo,
    title: 'PEI',
  },
  {
    src: piperSandlerLogo,
    title: 'Piper Sandler',
  },
  {
    src: raymondJamesLogo,
    title: 'Raymond James',
  },
  {
    src: RBCLogo,
    title: 'RBC',
  },
  {
    src: scotiabankLogo,
    title: 'Scotiabank',
  },
  {
    src: SMBCLogo,
    title: 'SMBC',
  },
  {
    src: solomonPartnersLogo,
    title: 'Solomon Partners',
  },
  {
    src: SVBleerinkLogo,
    title: 'SVBleerink',
  },
  {
    src: TMCapitalLogo,
    title: 'TM Capital',
  },
  {
    src: UBSLogo,
    title: 'UBS',
  },
  {
    src: wellsFargoLogo,
    title: 'Wells Fargo',
  },
  {
    src: williamBlairLogo,
    title: 'William Blair',
  },
];

const privateEquityCustomers: ICustomer[] = [
  {
    src: LCapitalLogo,
    title: 'LCapital',
  },
  {
    src: apolloLogo,
    title: 'Apollo',
  },
  {
    src: aviditiLogo,
    title: 'Aviditi',
  },
  {
    src: beachPointLogo,
    title: 'Beach Point',
  },
  {
    src: blackRockLogo,
    title: 'Black Rock',
  },
  {
    src: blackstoneLogo,
    title: 'Blackstone',
  },
  {
    src: carlyleLogo,
    title: 'Carlyle',
  },
  {
    src: cerberusLogo,
    title: 'Cerberus',
  },
  {
    src: endicottGroupLogo,
    title: 'Endicott Group',
  },
  {
    src: FFLLogo,
    title: 'FFL',
  },
  {
    src: HIGLogo,
    title: 'HIG',
  },
  {
    src: jadianCapitalLogo,
    title: 'Jadian Capital',
  },
  {
    src: KKRLogo,
    title: 'KKR',
  },
  {
    src: lorientLogo,
    title: 'Lorient Capital',
  },
  {
    src: manhattanVenturesLogo,
    title: 'Manhattan Venture Partners',
  },
  {
    src: moderneVenturesLogo,
    title: 'Moderne Ventures',
  },
  {
    src: heritageLogo,
    title: 'Heritage',
  },
  {
    src: oncapLogo,
    title: 'Oncap',
  },
  {
    src: pagayaLogo,
    title: 'Pagaya',
  },
  {
    src: patonaPartnersLogo,
    title: 'Patona Partners',
  },
  {
    src: pretiumLogo,
    title: 'Pretium',
  },
  {
    src: quilvestLogo,
    title: 'Quilvest',
  },
  {
    src: roakCapitalGroupLogo,
    title: 'Roark Capital Group',
  },
  {
    src: shoreViewLogo,
    title: 'Shore View',
  },
  {
    src: thomabravoLogo,
    title: 'Thomabravo',
  },
  {
    src: translinkLogo,
    title: 'Translink',
  },
  {
    src: tribecaLogo,
    title: 'Tribeca',
  },
  {
    src: vineVenturesLogo,
    title: 'Vine Ventures',
  },
];

const corporateCustomers: ICustomer[] = [
  {
    src: amherstLogo,
    title: 'Amherst',
  },
  {
    src: carvanaLogo,
    title: 'Carvana',
  },
  {
    src: CECEntertainmentLogo,
    title: 'CEC Entertainment',
  },
  {
    src: dellLogo,
    title: 'Dell',
  },
  {
    src: dominosLogo,
    title: 'Domino\'s',
  },
  {
    src: dunkinLogo,
    title: 'Dunkin',
  },
  {
    src: dyeAndDurhamLogo,
    title: 'Dye&Durham',
  },
  {
    src: fannieMaeLogo,
    title: 'Fannie Mae',
  },
  {
    src: fiveGuysLogo,
    title: 'Five Guys',
  },
  {
    src: fordLogo,
    title: 'Ford',
  },
  {
    src: freddieMacLogo,
    title: 'Freddie Mac',
  },
  {
    src: GMFinancialLogo,
    title: 'GMFinancial',
  },
  {
    src: hertzLogo,
    title: 'Hertz',
  },
  {
    src: HPLogo,
    title: 'HP',
  },
  {
    src: hiltonLogo,
    title: 'Hilton',
  },
  {
    src: holidayInnLogo,
    title: 'Holiday Inn',
  },
  {
    src: hondaLogo,
    title: 'Honda',
  },
  {
    src: hyundaiLogo,
    title: 'Hyundai',
  },
  {
    src: marriotLogo,
    title: 'Marriot',
  },
  {
    src: monsterLogo,
    title: 'Monster',
  },
  {
    src: nissanLogo,
    title: 'Nissan',
  },
  {
    src: pemexLogo,
    title: 'Pemex',
  },
  {
    src: resimacLogo,
    title: 'Resimac',
  },
  {
    src: soFiLogo,
    title: 'SoFi',
  },
  {
    src: teslaLogo,
    title: 'Tesla',
  },
  {
    src: toyotaLogo,
    title: 'Toyota',
  },
  {
    src: upstartLogo,
    title: 'Upstart',
  },
  {
    src: verizonLogo,
    title: 'Verizon',
  },
];

export const customersTabsList: ITabList[] = [
  {
    key: 'investmentBanking',
    label: 'Investment Banking',
    icon: IconBank,
    content: <SharedCustomers innerClassName={ styles.customerWrapper } customers={ investmentCustomers } />,
  },
  {
    key: 'privateEquityAndVentureCapital',
    label: 'Private Equity & Venture Capital',
    icon: IconUsersGroup,
    content: <SharedCustomers innerClassName={ styles.customerWrapper } customers={ privateEquityCustomers } />,
  },
  {
    key: 'corporate',
    label: 'Corporate',
    icon: IconAccount,
    content: <SharedCustomers innerClassName={ styles.customerWrapper } customers={ corporateCustomers } />,
  },
];
